// extracted by mini-css-extract-plugin
module.exports = {"player-icon-mask":"eB","playerIconMask":"eB","player-icon-box":"eC","playerIconBox":"eC"};